export default __webpack_public_path__ + "static/media/sg.81017386.svg";